import { render } from "./qk-sxpris-view.vue?vue&type=template&id=4ab489d1&scoped=true"
import script from "./qk-sxpris-view.vue?vue&type=script&setup=true&lang=js"
export * from "./qk-sxpris-view.vue?vue&type=script&setup=true&lang=js"

import "./qk-sxpris-view.vue?vue&type=style&index=0&id=4ab489d1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab489d1"],['__file',"src/views/tep/tep-nsi/qk-sxpris-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ab489d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ab489d1', __exports__)) {
    api.reload('4ab489d1', __exports__)
  }
  
  module.hot.accept("./qk-sxpris-view.vue?vue&type=template&id=4ab489d1&scoped=true", () => {
    api.rerender('4ab489d1', render)
  })

}


export default __exports__